import { translate } from 'App/Internationalization';
import BaseInput from 'shared/Forms/Inputs/BaseInput';
import React from 'react';

export default class InputCity extends React.Component {
	render() {
		const placeholder = translate(
			'global.forms.inputs.address.city.placeholder'
		);

		return (
			<BaseInput
				autocomplete="address-level2"
				className={this.props.className}
				disabled={this.props.disabled}
				name={this.props.name}
				placeholder={placeholder}
				required={this.props.required}
				type="text"
			/>
		);
	}
}

InputCity.defaultProps = {
	className: '',
	disabled: false,
	name: 'city',
	required: false,
};
